
import Fly from 'flyio/dist/npm/fly'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'
import {authRegister} from '@/api/user'

export default {
components: {
XButton,
Box,
Flexbox,
FlexboxItem,
IndexHeader,
IndexSidebar,
IndexFooter,
XInput,
Group,
Toast
},
data () {
return {
loginModel: {
mobile: '',
password: '',
identity: 'advertiser',
captcha: '',
msgcode: '',
captcha_token: '',
device: 'wap'
},
loginModel2: {
mobile: '',
password: '',
identity: 'advertiser',
captcha: '',
msgcode: '',
captcha_token: '',
device: 'wap'
},
getTextCode: '获取验证码',
captchaImg: '/static/images/vcode.jpg',
solutionList: [
{
toPath: '/solution/appPromotion',
iconName: 'jiejuefangan_apptuiguang',
solutionLabel: 'APP推广'
},
{
toPath: '/solution/smallProgram',
iconName: 'jiejuefangan_xiaochengxutuiguang',
solutionLabel: '小程序推广'
},
{
toPath: '/solution/game',
iconName: 'jiejuefangan-youxihangyetuiguang',
solutionLabel: '游戏行业推广'
},
{
toPath: '/solution/ecommerce',
iconName: 'jiejuefangan_dianshanghangyetuiguang',
solutionLabel: '电商行业推广'
},
{
toPath: '/solution/finance',
iconName: 'jiejuefangan_jinronghangyetuiguang',
solutionLabel: '金融行业推广'
},
{
toPath: '/solution/microBussiness',
iconName: 'jiejuefangan_weishanghangyetuiguang',
solutionLabel: '微商行业推广'
},
{
toPath: '/solution/tourism',
iconName: 'jiejuefangan_lvyouhangyetuiguang',
solutionLabel: '旅游行业推广'
},
{
toPath: '/solution/fmcg',
iconName: 'jiejuefangan_kuaixiaopinhangyetuiguang',
solutionLabel: '快消品行业推广'
},
{
toPath: '/solution/fashionBeauty',
iconName: 'jiejuefangan_shishangmeirongtuiguang',
solutionLabel: '时尚美容推广'
},
{
toPath: '/solution/newProduct',
iconName: 'jiejuefangan_xinpintuiguang',
solutionLabel: '新品推广'
},
{
toPath: '/solution/motherChild',
iconName: 'jiejuefangan_muyinghangyetuiguang',
solutionLabel: '母婴行业推广'
},
{
toPath: '/solution/car',
iconName: 'jiejuefangan_qichehangyetuiguang',
solutionLabel: '汽车行业推广'
}
],
smsCount: 0,
smsDisable: false
}
},
methods: {

getCaptcha () {
let fly = new Fly() 
fly.config.withCredentials = true  
fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
method: 'post'
}).then(resp => {
this.captchaImg = resp.data.data.src
this.loginModel.captcha_token = resp.data.data.captcha_token
this.loginModel2.captcha_token = resp.data.data.captcha_token
}).catch((e) => console.log('error', e))
},

getTextCaptcha (type) {
if (!this.smsDisable) {
if (type === 2) {
if (!this.loginModel2.captcha) {
this.$vux.toast.show({
text: '请输入正确的验证码',
time: 1000
})
this.getCaptcha()
return false
} else if (!this.loginModel2.mobile) {
this.$vux.toast.show({
text: '请输入手机号',
time: 1000
})
return false
}
} else {
if (!this.loginModel.captcha) {
this.$vux.toast.show({
text: '请输入正确的验证码',
time: 1000
})
this.getCaptcha()
return false
} else if (!this.loginModel.mobile) {
this.$vux.toast.show({
text: '请输入手机号',
time: 1000
})
return false
}
}

const textCaptchaModel = type === 2 ? {
captcha: this.loginModel2.captcha,
captcha_token: this.loginModel2.captcha_token,
mobile: this.loginModel2.mobile,
scope: 'mobile_signup'
}
: {
captcha: this.loginModel.captcha,
captcha_token: this.loginModel.captcha_token,
mobile: this.loginModel.mobile,
scope: 'mobile_signup'
}
let fly = new Fly() 
fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
method: 'post'
}).then(resp => {
if (!resp.data.success) {
this.getCaptcha()
} else {
this.smsCountDown()
}
this.$vux.toast.show({
text: resp.data.message,
time: 1000
})

}).catch((e) => console.log('获取短信验证码失败', e))
}
},

smsCountDown () {
const _this = this
_this.smsCount = 60
_this.smsDisable = true
let interval = window.setInterval(function () {
--_this.smsCount
if (_this.smsCount === 0) {
_this.smsDisable = false
window.clearInterval(interval)
}
}, 1000)
},


login (type) {





































const password = Math.random().toString().substr(2).slice(0, 6)

const registerModel = type === 2 ? {
mobile: this.loginModel2.mobile,
password,
identity: 'advertiser',
captcha: this.loginModel2.captcha,
captcha_token: this.loginModel2.captcha_token,
captcha_sms: this.loginModel2.msgcode,
scope: 'mobile_signup',
device: 'wap'
} : {
mobile: this.loginModel.mobile,
password,
identity: 'advertiser',
captcha: this.loginModel.captcha,
captcha_token: this.loginModel.captcha_token,
captcha_sms: this.loginModel.msgcode,
scope: 'mobile_signup',
device: 'wap'
}
authRegister(registerModel).then(res => {
this.$vux.toast.show({
text: res.message,
time: 1000
})
window._taq.push({convert_id: '1613933449992238', event_type: 'form'})
this.$router.push('/media?tab=woa')
}).catch((e) => {
console.log('注册失败', e)
this.$vux.toast.show({
text: e.message,
type: 'cancel',
time: 2000
})
this.getCaptcha()
this.loginModel.captcha = ''
this.loginModel2.captcha = ''
})
}
},
mounted () {
this.getCaptcha()
}
}



// WEBPACK FOOTER //
// ./src/pages/newguestwx/index.vue